<template>
    <div class="breadcrumbs">
        <div class="breadcrumbs-links">
            <a v-for="(link, index) in links" :key=index @click="link.onClick">
                <paragraph
                    class="breadcrumbs-link"
                    :class="{'default-text': !isTheLastLink(index) || !moreThanOneLink, 'highlight-text': isTheLastLink(index) && moreThanOneLink}"
                    :type="'p'"
                    :variation="'button-medium'">
                        {{ link.text }} {{ isTheLastLink(index) ? "" : " /" }}
                </paragraph>
            </a>
        </div>
    </div>
</template>

<script>
import Paragraph from '~/components/shared/paragraph.vue';

export default {
    name: 'breadcrumbs',
    components: { Paragraph },
    props: {
        links: {
            type: Array,
        },
    },
    computed: {
        moreThanOneLink() {
            return this.links.length > 1;
        },
    },
    methods: {
        isTheLastLink(index) {
            return index === this.links.length - 1;
        },
    },
};

</script>

<style lang="scss">

.breadcrumbs {
    &-links {
        display: flex;
    }

    &-link {
        cursor: pointer;
        margin-right: 5px;
        color: $color-neutral-dark-200;

        &.default-text {
            font-weight: 400;
        }

        &.highlight-text {
            color: $color-semantic-blue-300;
        }
    }
}

</style>
